const initialState = {
    factors: [],
    title: '',
    fromDate: '', 
    startTime: '',
    toDate: '', 
    endTime: '',
    branchOptions: [],
    branchSelect: null,
};

const installmentsFactor = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_INPUT_PAGE_INSTALLMENTS_FACTOR':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default installmentsFactor;
